const Data = [
    {
        name:"Nick knight",
        email:"example@company.com",
        profile:'',
        status:"verified",
        contact:"This is the message subjected to forward to the owner of the corporation"
    },
    {
        name:"haujoo",
        email:"example@company.com",
        profile:'',
        status:"",
        contact:"This is the contact subjected to forward to the owner of the corporation"
    },
    {
        name:"guileermo",
        email:"example@company.com",
        img:'',
        status:"",
        contact:"This is the contact subjected to forward to the owner of the corporation"
    },
    {
        name:"John Doe",
        email:"example@company.com",
        img:'',
        status:"",
        contact:"This is the contact subjected to forward to the owner of the corporation"
    },
    {
        name:"Nick knight",
        email:"example@company.com",
        profile:'',
        status:"verified",
        contact:"This is the contact subjected to forward to the owner of the corporation"
    },
    {
        name:"mayank",
        email:"example@company.com",
        profile:'',
        status:"verified",
        contact:"This is the contact subjected to forward to the owner of the corporation"
    },
]
export default Data